import React, { useState } from 'react';
import styles from './Login.module.css';
import { useTranslation } from 'react-i18next';
import { login } from '../../services/authService';
import { CustomButton, CustomInputText, CustomTitle, CustomLoader, CustomLink } from '../../components';
import { useDispatch } from 'react-redux';
import { loginRdx } from '../../store/authSlice';
import { useNavigate } from 'react-router-dom';

const Login = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [helperText, setHelperText] = useState('');


    const isFormComplete = () => {
        return identifier !== "" && password !== ""
    }

    const sendLogin = async () => {
        try {
            setIsLoading(true);

            const res = await login(identifier, password);

            if (res?.data?.user) {
                const token : string = res?.data.jwt;
                const userId : string = res?.data.user.id;
                const userType : string = res?.data.user.userType;
                const isTrustedUser : boolean = res?.data.user.isTrustedUser;

                const req = {
                    token : token,
                    userId : userId,
                    userType : userType,
                    isTrustedUser : isTrustedUser,
                }

                dispatch(loginRdx(req));
                setIsLoading(false);

                if (token)
                    navigate('/account');
            } else {
                setHelperText(t('login.wrong_login'));
                setIsLoading(false);
            }
        } catch (e) {
            console.error(e);
            setIsLoading(false);
            throw e;
        }
    }

    const onChangeIdentifier = (value: string) => {
        setHelperText('');
        setIdentifier(value)
    }

    const onChangePassword = (value: string) => {
        setHelperText('');
        setPassword(value)
    }

    return (
        <div className={ styles.container }>
            <div>
                <CustomTitle className={styles.title}>{ t('login.login') }</CustomTitle>

                <div className={styles.form}>
                    <CustomInputText id="identifier" label={t('login.identifier')} type="text" textValue={identifier} setTextValue={(value) => { onChangeIdentifier(value) }} required />
                    <CustomInputText id="password" label={t('signin.password')} type="password" textValue={password} setTextValue={(value) => { onChangePassword(value) }} helperText={helperText} error={helperText !== ''} required />

                    <div className={styles.sendBtn}>
                        <CustomButton disabled={!isFormComplete()} onClick={() => { sendLogin() }}>{ t('general.confirm') }</CustomButton>
                        <CustomLink to='/forgot_password_email' className={styles.forgot_password}>{t('login.forgot_password')}</CustomLink>
                        <CustomLink to='/account_confirmation_send' className={styles.resend_email}>{t('login.send_confirmation_email')}</CustomLink>
                        <span className={styles.noAccountContainer}>{t('login.no_account')} <CustomLink to='/signin' className={styles.noAccount}>{t('login.signin')}</CustomLink></span>
                    </div>
                </div>
            </div>

            <CustomLoader isLoading={isLoading}/>
        </div>
    )
}

export default Login;